var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 29,
    viewBox: "0 0 29 29",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h29v29h-29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.25 14.5c0-.942.156-1.845.435-2.692l-4.887-3.732c-.952 1.934-1.488 4.114-1.488 6.424 0 2.309.537 4.486 1.487 6.419l4.885-3.739c-.277-.843-.431-1.743-.431-2.68",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.83 5.932c2.046 0 3.894.725 5.346 1.911l4.224-4.218c-2.574-2.24-5.874-3.625-9.57-3.625-5.738 0-10.67 3.282-13.032 8.076l4.887 3.732c1.126-3.418 4.336-5.876 8.145-5.876",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.83 23.068c-3.809 0-7.019-2.458-8.145-5.876l-4.887 3.73c2.362 4.797 7.294 8.078 13.032 8.078 3.542 0 6.923-1.258 9.46-3.614l-4.637-3.586c-1.309.825-2.957 1.268-4.822 1.268",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.69 14.5c0-.857-.132-1.78-.33-2.636h-13.53v5.602h7.788c-.389 1.91-1.449 3.378-2.966 4.334l4.639 3.586c2.666-2.474 4.4-6.16 4.4-10.886",
    fill: "#4285f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogle);
export default __webpack_public_path__ + "static/media/login-google.f6d3f1b53cb89229c12d50dbb6e25f77.svg";
export { ForwardRef as ReactComponent };